export default "__VITE_ASSET__GbsUusSb__"